var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvtar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "PVR_Avatar_Common",
    clipPath: "url(#clip0_13086_43989)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20 0C8.97167 0 0 8.97167 0 20C0 31.0283 8.97167 40 20 40C31.0283 40 40 31.0283 40 20C40 8.97167 31.0283 0 20 0Z",
    fill: "#234B9E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13086_43989",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20 0C8.97167 0 0 8.97167 0 20C0 31.0283 8.97167 40 20 40C31.0283 40 40 31.0283 40 20C40 8.97167 31.0283 0 20 0Z",
    fill: "#FFCB05"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13086_43989)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 47575",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer 4",
    d: "M20.2 25.083C24.2132 25.083 28.062 26.6772 30.8997 29.515C33.7375 32.3527 35.3317 36.2015 35.3317 40.2147H5.0683C5.0683 36.2015 6.66253 32.3527 9.50027 29.515C12.338 26.6772 16.1868 25.083 20.2 25.083Z",
    fill: "#D3DBEC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer 5",
    d: "M19.8122 23.783C24.0602 23.783 27.5038 20.3394 27.5038 16.0915C27.5038 11.8435 24.0602 8.3999 19.8122 8.3999C15.5643 8.3999 12.1207 11.8435 12.1207 16.0915C12.1207 20.3394 15.5643 23.783 19.8122 23.783Z",
    fill: "#D3DBEC"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13086_43989"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvtar);
export default __webpack_public_path__ + "static/media/avtar.16c88c714e627f033978525f0b811766.svg";
export { ForwardRef as ReactComponent };